import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { ROUTES } from "@/constants/routeConstants";

/**
 * NotFound component displays a user-friendly 404 page
 * Provides navigation back to main application areas
 */
export const NotFound = () => {
  return (
    <div className="flex flex-col justify-center items-center h-screen text-center">
      <div className="px-6 space-y-6 max-w-md">
        <h1 className="text-4xl font-bold tracking-tighter">Page not found</h1>
        <p className="text-muted-foreground">
          Sorry, we couldn&apos;t find the page you&apos;re looking for. It
          might have been moved, deleted, or never existed.
        </p>
        <div className="flex flex-col gap-4 justify-center sm:flex-row">
          <Button asChild variant="default">
            <Link to={ROUTES.HOME}>Return to Dashboard</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};
